<div class="dashboard-container">

  <div *ngIf="!token" class="auth-container">
    <h1>¡Te damos la bienvenida!</h1>
    <h2>Regístrate o inicia sesión para continuar tu experiencia de compra.</h2>

    <div *ngIf="!showForgotPassword">
      <form [formGroup]="contactForm">
        <div class="controles-container">
          <mat-form-field appearance="outline">
            <mat-label>Correo</mat-label>
            <input matInput type="text" placeholder="Tu correo electrónico" formControlName="email"/>
          </mat-form-field>
        </div>
        <div class="controles-container">
          <mat-form-field appearance="outline">
            <mat-label>Contraseña</mat-label>
            <input matInput [type]="hide ? 'password' : 'text'" placeholder="Tu contraseña" formControlName="password"/>
            <span mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Ocultar contraseña'" [attr.aria-pressed]="hide">
              <mat-icon>{{ hide ? "visibility_off" : "visibility" }}</mat-icon>
            </span>
          </mat-form-field>
        </div>
        <mat-error *ngIf="error" class="error-message">
          {{ error }}
        </mat-error>
        <div class="auth-actions">
          <button type="submit" mat-flat-button color="primary" [disabled]="!contactForm.valid" class="login-btn" (click)="onLogin()">
            Login
          </button>
          <button type="submit" mat-flat-button color="accent" [disabled]="!contactForm.valid" class="register-btn" (click)="register()">
            Registrarme
          </button>
        </div>
        
        <div class="forgot-password-link-container">
          <span class="toggle-text" (click)="toggleForgotPassword()">
            <u class="hover-effect">¿Olvidaste tu contraseña?</u>
          </span>
        </div>
      </form>
    </div>

    <div *ngIf="showForgotPassword" class="forgot-password-container">
      <h2>Restablecer tu contraseña</h2>
      <form (ngSubmit)="resetPassword()">
        <div class="form-group">
          <label for="email">Ingresa tu correo electrónico</label>
          <input
            type="email"
            id="email"
            [(ngModel)]="email"
            name="email"
            class="form-control"
            required
          />
        </div>
        <div class="message-info">{{ message }}</div>
        <div class="d-flex align-items-center form-actions">
          <mat-icon (click)="toggleForgotPassword()" class="me-2 icon-hover back-icon" style="cursor: pointer;">arrow_back</mat-icon>
          <button type="submit" mat-flat-button color="primary" [disabled]="loading" class="btn-reset">
            <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>
            <span *ngIf="!loading">Enviar enlace al correo</span>
          </button>
        </div>
      </form>
    </div>
  </div>

  <div *ngIf="token" class="order-list-container">
    <h2 class="order-list-title">Mis Pedidos</h2>
    <div *ngIf="orders.length === 0" class="no-orders-message">
      <p>Aún no tienes pedidos registrados. ¡Explora nuestros productos para comenzar!</p>
    </div>
    <div *ngFor="let order of orders" class="order-card mat-elevation-z4">
      <div class="order-header">
        <h3 class="order-title">Pedido ID: <span>{{ order.id }}</span></h3>
        <!--p class="order-user">Usuario: <span>{{ order.user }}</span></p-->
        <p class="order-email">Email: <span>{{ order.email }}</span></p>
      </div>
      <div class="order-body">
        <p class="order-name"><span><mat-icon>person_outline</mat-icon> Nombre:</span> <span>{{ order.name }}</span></p>
        <p class="order-status"><span><mat-icon>local_shipping</mat-icon> Estatus:</span> <span>{{ order.status }}</span></p>
        <p class="order-shipping"><span><mat-icon>redeem</mat-icon> Método de Envío:</span> <span>{{ order.shippingMethod }}</span></p>
        <p class="order-total"><span><mat-icon>attach_money</mat-icon> Total Pagado:</span> <span class="order-total-amount">${{ order.totalPayment | number:'1.2-2' }}</span></p>
        <p class="order-create-date"><span><mat-icon>event</mat-icon> Fecha de Creación:</span> <span>{{ order.createAt ? translateDate(order.createAt) : 'N/A'  }}</span></p>
        <p><span><mat-icon>calendar_today</mat-icon> Fecha estimada de entrega:</span>
          <strong>
            entre {{ order.createAtPlus5BusinessDays ? translateDate(order.createAtPlus5BusinessDays) : 'N/A' }} y
            {{ order.createAtPlus20BusinessDays ? translateDate(order.createAtPlus20BusinessDays) : 'N/A' }}
          </strong>
        </p>
      </div>
      <div class="order-actions">
        <button mat-raised-button color="primary" (click)="viewOrderDetails(order)">Ver Detalles</button>
      </div>
    </div>
  </div>
</div>